module.exports = __webpack_public_path__ + "static/media/bg_business_partner.8e85ee53.jpg";